import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectUndeployApps } from './SelectUndeployAppsExtension';

export const SelectUndeployAppsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectUndeployApps',
    component: SelectUndeployApps,
  }),
);

